import type { Constants } from '@salesforce/scv-connector-base';
import { PhoneCall } from '@salesforce/scv-connector-base';
import { ContactGenerator } from '@main/generators/contact.generator';
import { PhoneCallAttributesGenerator } from '@main/generators/phone-call-attributes.generator';
import { CallInfoGenerator } from '@main/generators/call-info.generator';

export class PhoneCallGenerator {
  static generate(
    callId: string,
    callType: Constants.CALL_TYPE,
    phoneNumber: string,
  ): PhoneCall {
    return new PhoneCall({
      callId,
      phoneNumber,
      callType,
      contact: ContactGenerator.generate(phoneNumber),
      callAttributes: PhoneCallAttributesGenerator.generate(),
      callInfo: CallInfoGenerator.generate(callId),
    });
  }
}
